"use client";

import { useEffect, useState } from "react";

import { retrieveRawInitData } from "@telegram-apps/sdk";

import { NotFound } from "./components/NotFound";
import { Welcome } from "./components/Welcome";
import { Profile } from "./components/Profile";
import { Layout } from "../components/Layout";
import type { UserType } from "../types";

export default function MiniApp() {
  const [userState, setUserState] = useState("loading");
  const [user, setUser] = useState<UserType | null>(null);
  const [users, setUsers] = useState<UserType[]>([]);

  const fetchUser = async () => {
    try {
      const initDataRaw = new URLSearchParams(retrieveRawInitData() ?? "");
      const telegramUser = JSON.parse(initDataRaw.get("user") ?? "{}");
      
      // Note: telegramUser.id is the telegram_id
      const telegramId = telegramUser.id;
      
      if (!telegramId) {
        console.error("No telegram ID found in initData");
        setUserState("error");
        return;
      }

      const response = await fetch("/api/users/" + telegramId);
      
      if (!response.ok) {
        console.error(`Failed to fetch user: ${response.status}`);
        setUserState("error");
        return;
      }
      
      const data = await response.json();

      if (data.success && data.user) {
        setUserState(data.user.state);
        setUser(data.user);
      } else {
        console.error("Invalid response format:", data);
        setUserState("error");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      setUserState("error");
    }
  };

  useEffect(() => {
    fetchUser();
    // Fetch all users for the welcome screen
    fetch("/api/users/list")
      .then(response => response.json())
      .then(data => {
        if (data.success && data.users) {
          setUsers(data.users);
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error);
      });
  }, []);

  if (userState === "loading") {
    return (
      <Layout>
        <div className="text-center">Loading...</div>
      </Layout>
    );
  }

  if (userState === "preview") {
    return (
      <Layout>
        <Profile user={user} onUpdate={fetchUser} />
      </Layout>
    );
  }

  if (userState === "confirmed") {
    if (!user) {
      return;
    }

    const filteredUsers = users.filter((u) => u.id !== user.id).slice(0, 8);

    return (
      <Layout>
        <Welcome users={filteredUsers} owner={user} />
      </Layout>
    );
  }

  return (
    <Layout>
      <NotFound />
    </Layout>
  );
}
